<template>
  <div>
    <div class="xsmall-hide small-hide bg-1">
    </div>
    <div class="medium-hide large-hide xlarge-hide">
      <img src="../assets/naniungo-slide-21.jpg">
    </div>
    <div>
    </div>
      <div class="message">
        <p>
          Wir suchen zum schnellstmöglichen Zeitpunkt eine/n
        </p>
        <h1>{{ vacancy.titleInformation }}</h1>
        <p>
          Stellen-ID: {{vacancy.carerix_id}}
        </p>
      </div>
    <div class="md-layout">
      <div class="md-layout-item md-layout-size-20">
      </div>
      <div class="md-layout-item md-layout-size-80 md-elevation-5"
           style="min-width:80%; padding:50px; margin-top:50px;">
        <p>
          Ansprechpartner: <span style="margin-top:-20px;" v-html="vacancy.applicationContactInformation"></span>
        </p>
        <h1>{{vacancy.titleInformation}}</h1>

        <h3>Beschreibung</h3>
        <div v-html="vacancy.introInformation"></div>
        <h3>Beschreibung</h3>
        <div v-html="vacancy.vacancyInformation"></div>
        <h3>Anforderungen</h3>
        <div v-html="vacancy.requirementsInformation"></div>
        <br>
        <br>
        <br>
        <application-form v-bind:is-dark="true"></application-form>
      </div>
      <div class="md-layout-item md-layout-size-20">
      </div>
    </div>
    <div class="message dark secondary mt-40">
      <router-link style="width:100%;"
                   v-bind:to="'/publications'"
                   exact>
        <h1>
          <md-icon class="green ml-20">arrow_backwards</md-icon>zurück zu den Stellen
        </h1>
      </router-link>
    </div>
  </div>

</template>

<script>
import { mapState } from "vuex";
import ApplicationForm from "../templates/ApplicationForm";

export default {
  name: "Vakanzen",
  components: {
    ApplicationForm
  },
  data() {
    return {
      vacancy: []
    };
  },
  computed: {
    ...mapState({
      publications: state => state.publications.publications,
    })
  },
  created() {
    this.$store.dispatch("publications/getPublications");
  },
  methods: {
    // ...mapActions("publications", [
    //   ("getPublications")
    // ]),
  },
  watch: {
    publications: {
      handler() {
        this.vacancy = this.$store.state.publications.publications.filter(obj => {
          return obj.carerix_id === this.$route.params.id;
        })[0];
      },
      deep: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/shared.scss";
.bg-1 {
  background: url("../assets/naniungo-slide-21.jpg") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 400px;
  background-position: right 0px top -80px !important;
}

@media (min-width: 1600px){
  .bg-1 {
    height: 500px;
  }
}
@media (min-width: 1800px){
  .bg-1 {
    height: 500px;
    background-position: right 0px top -150px !important;
  }
}

.profiles {
  margin-left: 10px;
  margin-right: 10px;

  .md-card-header {
    padding: 16px;
  }

  .md-card {
    margin: 10px;
    width: 55vw;
    display: inline-block;
    vertical-align: top;
  }

  @media (min-width: 300px) and (max-width: 1300px) {
    .md-card {
      width: 50vw;
    }
  }

  .md-title {
    // margin-right:80px !important;
    h3 {
      font-size: 30px !important;
      margin-top: -2px;
      font-weight: 900;
    }
  }
  .md-subhead {
    // margin-right:80px !important;
    p {
      font-size: 16px !important;
      color: $primary-font;
    }
  }
  .md-card-actions {
    margin-bottom: 5px;
    margin-right: 5px;
  }
}

@media (min-width: 947px) {
  .blog {
    h1 {
      font-size: 50px;
      line-height: 56px;
      font-weight: 300;
    }
    p {
      font-size: 20px;
      line-height: 28px;
    }
  }
}
@media (max-width: 946px) {
  .blog {
    h1 {
      font-size: 30px;
      line-height: 36px;
      font-weight: 300;
    }
    p {
      font-size: 15px;
      line-height: 20px;
    }
  }
}

.blog {
  margin-left: 10vw;
  margin-right: 10vw;
}
</style>
